const $ = require('jquery');

// clipboard
const ClipboardJS = require('clipboard');

// awesome-notifications
import AWN from 'awesome-notifications';

let notifier = new AWN({
  durations: {
    global: 2000, success: 2000,
  },
});

// tippy
import tippy from 'tippy.js';

/**
 * pa function
 * @param str
 */
window.pa = function(str) {
  console.log(str);
};

/**
 * init tooltip
 */
window.initTooltip = function() {
  const types = {
    'top': '.tooltip-top',
    'bottom': '.tooltip-bottom',
    'left': '.tooltip-left',
    'right': '.tooltip-right',
  };

  Object.entries(types).forEach(entry => {
    const [key, value] = entry;

    tippy(document.querySelectorAll(value), {
      content: (reference) => reference.getAttribute('data-title'), allowHTML: true, duration: 0, placement: key, trigger: 'mouseenter focus click',
    });
  });
};

window.destroyTooltips = function() {
  const types = {
    'top': '.tooltip-top', 'right': '.tooltip-right', 'bottom': '.tooltip-bottom', 'left': '.tooltip-left',
  };

  Object.entries(types).forEach(entry => {
    const [key, value] = entry;

    [...document.querySelectorAll(value)].forEach(node => {
      if (node._tippy) {
        node._tippy.destroy();
      }
    });
  });
};

/**
 * initClipboard
 */
let clipboard;
window.initClipboard = function(element) {
  if (typeof clipboard !== 'undefined') {
    clipboard.destroy();
  }

  clipboard = new ClipboardJS(element);

  clipboard.on('success', function(e) {
    setAwnNotification('success', LANG_STRINGS.kopiert, LANG_STRINGS.inZwischenAblageKopiert);
    e.clearSelection();
  });

  return false;
};

/**
 * setAwnNotification
 * @param type
 * @param title
 * @param message
 */
window.setAwnNotification = function(type = 'success', title = '', message = '') {
  if (type !== '' && message !== '') {
    if (type === 'success') {
      notifier.success(message, {labels: {success: title}});
    } else if (type === 'warning') {
      notifier.warning(message, {labels: {warning: title}});
    } else if (type === 'alert') {
      notifier.alert(message, {labels: {alert: title}});
    }
  }
};

/**
 * AjaxItem
 *
 * @param item
 * @param getData
 * @param params
 * @param path
 * @constructor
 */
window.AjaxItem = function(item, getData, params, path = '') {
  if (typeof item != 'string') {
    return;
  }
  if (typeof params != 'object') {
    params = {};
  }

  getData = getData || {};
  const self = this;

  let ajaxPath = '';
  if (path !== '') {
    ajaxPath = path + '/';
  }

  const defaults = {
    container: '#list_' + item, ajaxFile: BASE_PATH + 'ajax/list/' + ajaxPath + 'ajax.' + item, callback: function() {
    },
  };
  let config = $.extend(defaults, params);

  /**
   * sortBy
   * @param sortby
   */
  this.sortBy = function(sortby) {
    self.updater({sortby: sortby});
  };

  /**
   * changePage
   * @param page
   */
  this.changePage = function(page) {
    self.updater({page: page});
  };

  /**
   * Fügt weitere Elemente aus einem Object hinzu, um diese mit einem späteren Aufruf von updater() zu berücksichtigen
   * @param name
   * @param filter
   */
  this.addFilter = function(name, filter) {
    if (typeof filter == 'object') {
      let filt = [];
      $(filter).each(function() {
        filt[filt.length] = $(this).val();
      });

      let temp = {};
      temp[name] = filt;
      getData = $.extend({}, getData, temp);
    }
  };

  /**
   * loader
   */
  this.loader = function() {
    $.ajax({
      url: config.ajaxFile + '?' + $.param(getData), beforeSend: function() {
        $(config.container).html('');
        self.showLoader();
      }, success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  /**
   * updater
   * @param getUpdater
   */
  this.updater = function(getUpdater) {
    let data = (typeof getUpdater != 'undefined' ? getUpdater : {});
    data = $.extend(data, {ajax: 1});

    $.ajax({
      url: config.ajaxFile + '?' + $.param(getData), type: 'get', data: data, beforeSend: function() {
        self.showLoader();
      }, success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  /**
   * poster
   * @param postData
   */
  this.poster = function(postData) {
    let data = (typeof postData != 'undefined' ? postData : {});
    data = $.extend(data, {ajax: 1});
    $.ajax({
      url: config.ajaxFile, type: 'post', data: data, beforeSend: function() {
        self.showLoader();
      }, success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  /**
   * afterLoad
   */
  this.afterLoad = function() {
    if (typeof config.callback == 'function') {
      config.callback();
    }

    iOSInputFix();

    $(config.container).css({
      'minHeight': 'auto',
    });
  };

  /**
   * showLoader
   */
  this.showLoader = function() {
    insertAutoLoader($(config.container));
  };
};

/**
 * insert AutoLoader
 * @param into
 */
window.insertAutoLoader = function(into = 'body') {
  if ($(into).find('.ajaxLoader').length === 0) {
    $(into).css({
      'position': 'relative', 'minHeight': '150px',
    });
    $(into).append('<div class="ajaxLoader"><div class="loader">Loading...</div></div>');
  }
};

/**
 * Remove AutoLoader
 */
window.removeAutoLoader = function() {
  const ajaxLoader = $('.ajaxLoader');
  if (ajaxLoader.length > 0) {
    ajaxLoader.remove();
  }
};

/**
 * ajaxDialog
 * @param file
 * @param maxWidth
 * @param params
 */
window.ajaxDialog = function(file, maxWidth, params) {
  const self = $(this);
  const body = $('body');

  // Default für maxWidth des PopUps definieren
  maxWidth = maxWidth || 742;

  // Close-Icon
  const closeHtml = '<button type="button" class="btn-close" aria-label="Close" onclick="ajaxDialog(\'close\');"><i class="material-icons">close</i></button>';

  /**
   * show
   */
  self.show = function() {
    // modal backdrop
    const popUpBackDrop = $('body .modal-backdrop');
    if (popUpBackDrop.length === 0) {
      body.append('<div class="modal-backdrop"></div>');
    }

    body.append('<div class="modal" tabindex="-1"><div class="modal-dialog" style="max-width:' + maxWidth + 'px;"><div class="modal-content"></div></div></div>');

    const popup = $('body .modal').last();

    if (typeof file == 'string') {
      self.loadData();
    }
    if (typeof file == 'object') {
      popup.find('.modal-content').html(file.html());
    }

    checkOpenDialog();
  };

  /**
   * loadData
   */
  self.loadData = function() {
    $.ajax({
      url: file, type: 'post', data: config.post_data, beforeSend: function() {
        insertAutoLoader($('body .modal').last().find('.modal-content'));
      }, success: function(html) {
        const popup = $('body .modal').last().find('.modal-content');
        popup.html(html).find('.modal-header').append(closeHtml);

        if (popup.find('form').attr('action') === '') {
          popup.find('form:first').submit(function() {
            config.post_data = $(this).find('input:not([type=checkbox],[type=radio],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select');

            self.loadData();
            return false;
          });
        }

        if (typeof config.callback == 'function') {
          config.callback();
        }

        iOSInputFix();
      },
    });
  };

  /**
   * close
   */
  self.close = function() {
    if (typeof overwriteClose == 'function' && typeof overwriteClose !== 'undefined') {
      overwriteClose();
    }

    const popUpWrap = $('body .modal');

    popUpWrap.last().remove();
    if ($('body .modal ').length === 0) {
      $('body .modal-backdrop').remove();
    }

    checkOpenDialog();
  };

  // Hier gehts los
  if (typeof file == 'object' && $(file).attr('href')) {
    file = $(file).attr('href');
  } else if (typeof file == 'object') {
    file = $(file);
  }

  if (file === 'close') {
    self.close();
    return;
  }

  if (typeof params != 'object') {
    params = {};
  }

  const defaults = {
    width: 0, callback: function() {
    }, post_data: {},
  };
  const config = $.extend(defaults, params);

  self.show();
};

/**
 * checkOpenDialog
 */
window.checkOpenDialog = function() {
  const popupWrap = $('.modal');
  const body = $('body');
  if (popupWrap.length) {
    if (!body.hasClass('overflow-hidden')) {
      body.addClass('overflow-hidden');
    }
  } else {
    if (body.hasClass('overflow-hidden')) {
      body.removeClass('overflow-hidden');
    }
  }
};

/**
 * copyValue
 * @param element
 * @param inElement
 */
window.copyValue = function(element, inElement) {
  $(inElement).val($(element).val()).trigger('input');
};

/**
 * Full-Text Function
 * @param element
 * @param identifier
 * @param listObject
 */
window.fullTextSearch = function(element, identifier, listObject) {
  $(element).on('input', function() {
    updateListFilter($(this), identifier, listObject);
  });
};

/**
 * updateListFilter
 * @param object
 * @param identifier
 * @param filterTimeout
 * @param listObject
 */
let filterTimeout;
window.updateListFilter = function(object, identifier, listObject) {
  const inputVal = object.val();
  clearTimeout(filterTimeout);
  filterTimeout = setTimeout(function() {
    if (listObject.length > 1) {
      $.each(listObject, function(key, value) {
        value.updater({[identifier]: inputVal});
      });
    } else {
      listObject.updater({[identifier]: inputVal});
    }
  }, 1000);

  return filterTimeout;
};

/**
 * Check select all
 * @param tableElement
 * @param selectAll
 * @param rowSelect
 * @param editDataButton
 */
window.checkSelectList = function(tableElement, selectAll, rowSelect, editDataButton) {
  // Row select
  $(rowSelect).on('change', function() {
    checkSelected(tableElement, selectAll, rowSelect, editDataButton);
  });

  // all select
  $(selectAll).on('change', function() {
    if ($(this).is(':checked')) {
      $(tableElement).find(rowSelect).not(':disabled').prop('checked', true);
      $(tableElement).find('label[for="selectAll"]').html(LANG_STRINGS.deselectAll);
    } else {
      $(tableElement).find(rowSelect).not(':disabled').prop('checked', false);
      $(tableElement).find('label[for="selectAll"]').html(LANG_STRINGS.selectAll);
    }

    checkSelected(tableElement, selectAll, rowSelect, editDataButton, true);
  });

  /**
   * Check selected
   * @param tableElement
   * @param selectAll
   * @param rowSelect
   * @param editDataButton
   * @param noAllSelected
   */
  window.checkSelected = function(tableElement, selectAll, rowSelect, editDataButton, noAllSelected = false) {
    let allSelected = true;
    let hasSelectedData = false;
    let hasRecords = false;
    $(tableElement).find(rowSelect).each(function() {
      hasRecords = true;

      if (!$(this).is(':checked')) {
        allSelected = false;
      } else {
        hasSelectedData = true;
      }
    });

    // All selected checkbox
    if (hasRecords === true && noAllSelected === false) {
      if (allSelected === true) {
        $(tableElement).find(selectAll).prop('checked', true);
        $(tableElement).find('label[for="selectAll"]').html(LANG_STRINGS.deselectAll);
      } else {
        $(tableElement).find(selectAll).prop('checked', false);
        $(tableElement).find('label[for="selectAll"]').html(LANG_STRINGS.selectAll);
      }
    }

    // Enable Buttons
    if (hasSelectedData === true) {
      $(editDataButton).removeAttr('disabled');
    } else {
      $(editDataButton).attr('disabled', 'disabled');
    }

    // Inderterminate State
    if (hasSelectedData === true && allSelected === false) {
      $(tableElement).find(selectAll).addClass('inderterminate');
    } else if (allSelected === true || hasSelectedData === false) {
      $(tableElement).find(selectAll).removeClass('inderterminate');
    }
  };

  checkSelected(tableElement, selectAll, rowSelect, editDataButton);
};

/**
 *  Checkboxen für table tr als Tree (maximal 5)
 * @param tableElement
 * @param selectAll
 * @param selectLevel
 * @param selectRow
 * @param editDataButton
 */
window.checkboxLevel = function(tableElement, selectAll, selectLevel, selectRow, editDataButton) {
  if ($(editDataButton).length > 0) {
    $(editDataButton).attr('disabled', 'disabled');
  }

  $(selectAll).on('click', function(event) {
    event.stopPropagation();
    if ($(this).is(':checked')) {
      $(tableElement).find('input[type="checkbox"]' + selectLevel).removeClass('inderterminate').prop('checked', true);
      $(this).closest('label').find('.label').html(LANG_STRINGS.deselectAll);
    } else {
      $(tableElement).find('input[type="checkbox"]' + selectLevel).removeClass('inderterminate').prop('checked', false);
      $(this).closest('label').find('.label').html(LANG_STRINGS.selectAll);
    }

    updateCheckAllState(tableElement, selectAll, selectRow);
  });

  $(selectLevel).on('click', function(event) {
    event.stopPropagation();
    $(this).removeClass('inderterminate');

    // selektierte Row
    const selectedRow = $(this).closest('[data-level]');
    const isChecked = $(this).is(':checked');
    // selektiertes Level
    const rowLevel = selectedRow.data('level');
    if (typeof rowLevel !== 'undefined') {
      // Kinder-Checkboxen selektieren
      let nextUntilSelector = '[data-level="' + rowLevel + '"]';
      if (rowLevel > 1) {
        for (let i = (rowLevel - 1); i >= 1; i--) {
          nextUntilSelector += ',[data-level="' + i + '"]';
        }
      }
      const nextLevel = selectedRow.nextUntil(nextUntilSelector, '[data-level]');
      if (nextLevel.length) {
        nextLevel.find('input[type="checkbox"]' + selectLevel).removeClass('inderterminate').prop('checked', isChecked);
      }

      // wenn alle kinder ausgewählt sind auch das Elternelement auswählen
      let isInderterminate = false;
      if (rowLevel > 1) {
        for (let i = (rowLevel - 1); i >= 1; i--) {
          let parentRow = selectedRow.prevAll('[data-level="' + i + '"]').first();
          let parentRowCheckbox = parentRow.find('input[type="checkbox"]' + selectLevel);
          if (parentRow.length && parentRowCheckbox.length) {
            let parentRowCheckboxState = 'unchecked';
            let parentRowChildren = parentRow.nextUntil('[data-level="' + i + '"]', '[data-level="' + (i + 1) + '"]');

            let parentRowChildrenUncheckedExists = (parentRowChildren.find('input[type="checkbox"]' + selectLevel + ':not(:checked)').length);
            let parentRowChildrenCheckedExists = (parentRowChildren.find('input[type="checkbox"]' + selectLevel + ':checked').length);

            if (parentRowChildrenUncheckedExists === 0 && parentRowChildrenCheckedExists !== 0) {
              parentRowCheckboxState = 'checked';
            } else if (parentRowChildrenUncheckedExists !== 0 && parentRowChildrenCheckedExists !== 0) {
              parentRowCheckboxState = 'inderterminate';
              // inderterminate an die Eltern vererben
              isInderterminate = true;
            } else {
              parentRowCheckboxState = 'unchecked';
            }

            switch (parentRowCheckboxState) {
              case 'checked':
                $(parentRowCheckbox).removeClass('inderterminate').prop('checked', true);
                break;
              case 'inderterminate':
                $(parentRowCheckbox).addClass('inderterminate').prop('checked', false);
                break;
              default:
                if (isInderterminate) {
                  // Vererbung von Inderterminate von Kind
                  $(parentRowCheckbox).addClass('inderterminate').prop('checked', false);
                } else {
                  $(parentRowCheckbox).removeClass('inderterminate').prop('checked', false);
                }
            }
          }
        }
      }
    }

    updateCheckAllState(tableElement, selectAll, selectRow);
  });

  /**
   * CheckAll Checkbox-Status aktualisieren
   *
   * @param tableElement
   * @param selectAll
   * @param selectRow
   */
  window.updateCheckAllState = function(tableElement, selectAll, selectRow) {
    let selectAllState = 'unchecked';

    if ($(tableElement).length && $(selectAll).length) {
      const uncheckedExists = ($(tableElement).find('input[type="checkbox"]' + selectLevel + ':not(:checked)').length);
      const checkedExists = ($(tableElement).find('input[type="checkbox"]' + selectLevel + ':checked').length);
      const rowExists = ($(tableElement).find('input[type="checkbox"]' + selectRow + ':checked').length);

      if (uncheckedExists === 0 && checkedExists !== 0) {
        selectAllState = 'checked';
      } else if (uncheckedExists !== 0 && checkedExists !== 0) {
        selectAllState = 'inderterminate';
      } else {
        selectAllState = 'unchecked';
      }

      switch (selectAllState) {
        case 'checked':
          $(selectAll).removeClass('inderterminate').prop('checked', true);
          $(selectAll).closest('label').find('.label').html(LANG_STRINGS.deselectAll);
          break;
        case 'inderterminate':
          $(selectAll).addClass('inderterminate').prop('checked', false);
          $(selectAll).closest('label').find('.label').html(LANG_STRINGS.selectAll);
          break;
        default:
          $(selectAll).removeClass('inderterminate').prop('checked', false);
          $(selectAll).closest('label').find('.label').html(LANG_STRINGS.selectAll);
      }

      updateEditDataButtonState(editDataButton, (rowExists !== 0));
    }
  };

  /**
   *
   *
   * @param editDataButton
   * @param isEnabled
   */
  window.updateEditDataButtonState = function(editDataButton, isEnabled = false) {
    if ($(editDataButton).length) {
      if (isEnabled) {
        $(editDataButton).removeAttr('disabled');
      } else {
        $(editDataButton).attr('disabled', 'disabled');
      }
    }
  };
};

/**
 * Checks and validates editing actions for a specific line in a list of data.
 * This function allows the user to validate or modify a line of data in an editable interface
 * based on specific conditions or criteria. It ensures that the line of data meets the required
 * validation rules before any further action is performed.
 *
 * @param element
 * @param editDataButtonSelector
 */
window.editListDataLineCheck = function(element, editDataButtonSelector) {
  // Deselect all
  const rowTable = element.closest('div.row-table');
  const checkboxes = rowTable.querySelectorAll('input[type="checkbox"].select-level');
  checkboxes.forEach(cb => {
    cb.checked = false;
    cb.classList.remove('inderterminate');
  });

  // Select line
  const row = element.closest('div.row');
  const sectionCheckbox = row.querySelector('input[type="checkbox"].select-section');
  if (sectionCheckbox) sectionCheckbox.click();

  // Trigger button if not disabled
  const editButton = document.querySelector(editDataButtonSelector);
  if (editButton && !editButton.disabled) {
    editButton.click();
  }
};

/**
 * Get checked data
 * @param list
 * @returns {*[]}
 */
window.getCheckedData = function(list) {
  let listData = [];
  list.each(function() {
    listData.push($(this).val());
  });

  return listData;
};

/**
 * Number Format Funktion wie in PHP
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {string}
 */
window.numberFormat = function(number, decimals, dec_point, thousands_sep) {
  // Strip all characters but numerical ones.
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  let n = !isFinite(+number) ? 0 : +number, prec = !isFinite(+decimals) ? 0 : Math.abs(decimals), sep = (typeof thousands_sep === 'undefined') ? '' : thousands_sep, dec = (typeof dec_point === 'undefined') ? '.' : dec_point, s, toFixedFix = function(n, prec) {
    const k = Math.pow(10, prec);
    return '' + Math.round(n * k) / k;
  };

  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

/**
 * Round-Function
 * @param value
 * @param precision
 * @param mode
 * @returns {number}
 */
window.phpRound = function(value, precision, mode) {
  let m, f, isHalf, sgn; // helper variables
  // making sure precision is integer
  precision |= 0;
  m = Math.pow(10, precision);
  value *= m;
  // sign of the number
  sgn = (value > 0) | -(value < 0);
  isHalf = value % 1 === 0.5 * sgn;
  f = Math.floor(value);

  if (isHalf) {
    switch (mode) {
      case 'PHP_ROUND_HALF_DOWN':
        // rounds .5 toward zero
        value = f + (sgn < 0);
        break;
      case 'PHP_ROUND_HALF_EVEN':
        // rouds .5 towards the next even integer
        value = f + (f % 2 * sgn);
        break;
      case 'PHP_ROUND_HALF_ODD':
        // rounds .5 towards the next odd integer
        value = f + !(f % 2);
        break;
      default:
        // rounds .5 away from zero
        value = f + (sgn > 0);
    }
  }

  return (isHalf ? value : Math.round(value)) / m;
};

/**
 * Gibt einen numerischen Wert reformatiert aus
 * @param value
 * @param decimal
 * @returns {string}
 */
window.reformatNumeric = function(value, decimal) {
  // g-parameter, damit nicht nur der erste Punkt ersetzt wird!
  value = value.replace(/\./g, '', value);
  value = value.replace(/,/, '.', value);

  return numberFormat(value, decimal, '.', '');
};

/**
 * numberFormatAuto
 * @param value
 * @param decimals
 * @param minDecimals
 * @returns {string}
 */
window.numberFormatAuto = function(value, decimals, minDecimals) {
  if (decimals !== 0) {
    decimals = decimals || 3;
  }

  let dec = maxDecimals(value, decimals);
  if (minDecimals > 0) {
    if (dec < minDecimals) {
      dec = minDecimals;
    }
  }
  return numberFormat(value, dec, ',', '.');
};

/**
 * maxDecimals
 * @param value
 * @param decimals
 * @returns {*}
 */
window.maxDecimals = function(value, decimals) {
  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  for (let i = 0; i < decimals; i++) {
    // value * Math.pow(10, i) ergibt teilweise 000000000001 als Nachkommastellen!?
    // noinspection EqualityComparisonWithCoercionJS,JSCheckFunctionSignatures
    if (value * Math.pow(10, i) == parseInt(value * Math.pow(10, i))) {
      return i;
    }
  }
  return decimals;
};

/**
 * Expander
 * @param maxLevel
 */
window.expander = function(maxLevel = 0) {
  $('.expander').on('click', function(e) {
    e.stopPropagation();
    const row = $(this).closest('tr,.row');

    if (maxLevel === 0) {
      // Normal
      if ($(this).hasClass('icon_minus')) {
        row.nextUntil('.sbrItem').addClass('level-hide').hide();
        $(this).removeClass('icon_minus').html('expand_more');
      } else {
        row.nextUntil('.sbrItem').removeClass('level-hide').show();
        $(this).addClass('icon_minus').html('expand_less');
      }
    } else {
      // If has Leveling
      if ($(this).hasClass('icon_minus')) {
        row.nextUntil('.sbrItem').hide();
        $(this).removeClass('icon_minus').html('expand_more');
      } else {
        if (row.next('.expand-item').data('level' + maxLevel)) {
          // If last level
          row.nextUntil('.sbrItem').show();
        } else {
          row.next('.expand-item').show();
        }
        $(this).addClass('icon_minus').html('expand_less');
      }
    }
  });

  // Expand all Tr
  $('.expandAll').on('click', function(el) {
    const expander = $(el.target);
    let body;

    if (expander.closest('thead').length) {
      body = expander.closest('thead').next('tbody');
    } else {
      body = expander.closest('.row-table');
    }

    if (expander.hasClass('icon_minus')) {
      body.find('tr,.row').not('.sbrItem,.row-table__head,.row-table__foot').addClass('level-hide').hide();
      body.find('span.expander').removeClass('icon_minus').html('expand_more');
    } else {
      body.find('tr,.row').removeClass('level-hide').show();
      body.find('span.expander').addClass('icon_minus').html('expand_less');
    }
    expander.toggleClass('icon_minus').html(expander.html() === 'expand_more' ? 'expand_less' : 'expand_more');
  });
};

/**
 * Expander Level
 */
window.expanderLevel = function(expandElement = '.expander') {
  $(expandElement).on('click', function(e) {
    e.stopPropagation();
    const expanderItem = $(this);

    // selektierte Row
    const selectedRow = expanderItem.closest('[data-level]');
    // selektiertes Level
    const rowLevel = selectedRow.data('level');
    if (typeof rowLevel !== 'undefined') {
      if (!expanderItem.hasClass('icon_minus')) {
        if (selectedRow.data('expand-key') !== '') {
          fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveExpander', {
            method: 'POST', body: JSON.stringify({
              levels: {
                level1: (selectedRow.data('level1-id') ? selectedRow.data('level1-id') : 0),
                level2: (selectedRow.data('level2-id') ? selectedRow.data('level2-id') : 0),
                level3: (selectedRow.data('level3-id') ? selectedRow.data('level3-id') : 0),
                level4: (selectedRow.data('level4-id') ? selectedRow.data('level4-id') : 0),
              }, expandKey: selectedRow.data('expand-key'), state: 1,
            }),
          }).then(function(response) {
            return response.text();
          });
        }
      } else {
        if (selectedRow.data('expand-key') !== '') {
          fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveExpander', {
            method: 'POST', body: JSON.stringify({
              levels: {
                level1: (selectedRow.data('level1-id') ? selectedRow.data('level1-id') : 0),
                level2: (selectedRow.data('level2-id') ? selectedRow.data('level2-id') : 0),
                level3: (selectedRow.data('level3-id') ? selectedRow.data('level3-id') : 0),
                level4: (selectedRow.data('level4-id') ? selectedRow.data('level4-id') : 0),
              }, rowLevel: rowLevel, expandKey: selectedRow.data('expand-key'), state: 0,
            }),
          }).then(function(response) {
            return response.text();
          });
        }
      }

      // Nächstes Level
      const subrowLevel = (rowLevel + 1);
      const nextLevel = selectedRow.nextUntil('[data-level="' + rowLevel + '"]', '[data-level="' + subrowLevel + '"]');
      if (nextLevel.length) {
        nextLevel.each(function() {
          if (!expanderItem.hasClass('icon_minus')) {
            $(this).removeClass('level-hide');
          } else {
            $(this).addClass('level-hide');

            // damit die level unterhalb der ausgewählten auch eingeklappt werden
            let nextUntilFilter = '';
            for (let i = (rowLevel + 1); i < 20; i++) {
              if (nextUntilFilter !== '') {
                nextUntilFilter += ',';
              }
              nextUntilFilter += '[data-level="' + i + '"]';
            }
            selectedRow.nextUntil('[data-level="' + rowLevel + '"]', nextUntilFilter).addClass('level-hide');
          }
        });
        checkExpanderIcon();
      }
    }
  });

  /**
   * check expander icon
   */
  window.checkExpanderIcon = function() {
    $('.expander').each(function() {
      const element = $(this);
      // selektierte Row
      const selectedRow = $(this).closest('[data-level]');
      // selektiertes Level
      const rowLevel = selectedRow.data('level');
      if (typeof rowLevel !== 'undefined') {
        // Nächstes Level
        const subrowLevel = (rowLevel + 1);
        // Nächstes Level-Element sichtbar?
        const nextLevel = selectedRow.nextUntil('[data-level="' + rowLevel + '"]', '[data-level="' + subrowLevel + '"]:visible');
        if (nextLevel.length) {
          element.addClass('icon_minus').html('expand_less');
        } else {
          element.removeClass('icon_minus').html('expand_more');
        }
      }
    });
  };
};

/**
 * Upload File
 * @param element
 * @param type
 * @param inputHiddenName
 */
window.uploadFile = function(element, type, inputHiddenName) {
  const totalFiles = element.files.length;
  const formFieldFile = $(element).closest('div.form-field--file');
  const fileList = formFieldFile.find('.file-list');

  if (totalFiles > 0) {
    let formData = new FormData();

    // Read selected files
    for (let index = 0; index < totalFiles; index++) {
      formData.append('files[]', element.files[index]);
    }

    formFieldFile.removeClass('error');

    $.ajax({
      url: BASE_PATH + 'ajax/helper/additional/ajax.uploadFiles?type=' + type, type: 'post', data: formData, dataType: 'json', processData: false, contentType: false, success: function(res) {
        if (totalFiles <= 1) {
          fileList.html('');
        }

        $.each(res, function(key, value) {
          if (value.success === true) {
            fileList.append('<li><input type="hidden" name="' + inputHiddenName + '" value="' + value.filename + '"><a href="' + value.fileUrl + '" target="_blank"><span class="ellipsis">' + value.filename + '</span></a></li>');
            $(element).after('');
          } else {
            fileList.append('<li class="text-red">' + value.error + '</li>');
          }
        });
      },
    });
  } else {
    formFieldFile.addClass('error');
  }
};

/**
 * Set Bemerkung Input in dialog
 * @param valBefore
 * @param valDialog
 */
window.setBemerkungInput = function(valBefore, valDialog) {
  const textTmp = $(valBefore);
  if (textTmp.length > 0) {
    $(valDialog).val(textTmp.val());
  }
};

/**
 * Set Checkbox Input in dialog
 * @param valBefore
 * @param valDialog
 */
window.setCheckboxInput = function(valBefore, valDialog) {
  const textTmp = $(valBefore);
  if (textTmp.length > 0) {
    if (textTmp.val() !== '') {
      $(valDialog).prop('checked', true);
    } else {
      $(valDialog).prop('checked', false);
    }
  }
};

/**
 * Set Bemerkung in Frontend
 * @param hiddenField
 * @param button
 * @param bemerkung
 */
window.setBemerkungFrontend = function(hiddenField, button, bemerkung) {
  const textField = $(hiddenField);
  const buttonField = $(button);

  if (textField.length > 0) {
    textField.val(bemerkung);
  }

  if (buttonField.length > 0) {
    buttonField.find('i.material-icons').hide();
    if (bemerkung !== '') {
      buttonField.find('i.material-icons').show();
    }
  }
};

/**
 * Init Simple Calendar
 * @param listElement
 * @param inputElement
 * @param params
 */
window.initCalendar = function(listElement, inputElement, params = {}) {
  // Load Calendar
  $.ajax({
    url: BASE_PATH + 'ajax/helper/additional/ajax.getCalendar?init=1', type: 'get', data: params, beforeSend: function() {
      insertAutoLoader($(listElement));
    }, success: function(html) {
      $(listElement).html(html);
      selectDay(inputElement);
    },
  });

  // Update Calendar
  window.updateCalendar = function(listElement, inputElement, params) {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/additional/ajax.getCalendar', type: 'get', data: params, success: function(html) {
        $(listElement).html(html);
        selectDay(inputElement);
      },
    });
  };

  /**
   * Select Day
   * @param inputElement
   */
  window.selectDay = function(inputElement) {
    // Selected
    $('.calendar-month-days .selectable').on('click', function() {
      $('.calendar-month-days').find('.selected').removeClass('selected');

      $(inputElement).val($(this).data('value'));
      $(this).addClass('selected');

      updateCalendar(listElement, inputElement, {
        'selectedDate': $(this).data('value'),
      });
    });
  };

  /**
   * Update Month
   * @param element
   */
  window.updateMonthSelect = function(element) {
    updateCalendar(listElement, inputElement, {
      'selectedMonth': $(element).val(),
    });
  };

  /**
   * updateDateSwitcher
   * @param month
   */
  window.updateDateSwitcher = function(month) {
    const monthSwitcher = $('#month-switcher');
    const prevSwitcher = $('#prev-switcher');
    const nextSwitcher = $('#next-switcher');

    monthSwitcher.val(month);

    if (parseInt(month) === 12) {
      nextSwitcher.attr('disabled', 'disabled');
    } else {
      nextSwitcher.removeAttr('disabled');
    }

    if (parseInt(month) === 1) {
      prevSwitcher.attr('disabled', 'disabled');
    } else {
      prevSwitcher.removeAttr('disabled');
    }

    prevSwitcher.unbind('click');
    prevSwitcher.on('click', function() {
      let newMonth = parseInt(month) - 1;
      if (newMonth === 0) {
        newMonth = 12;
      }

      updateCalendar(listElement, inputElement, {
        'selectedMonth': newMonth,
      });

      updateDateSwitcher(newMonth);

      return false;
    });

    nextSwitcher.unbind('click');
    nextSwitcher.on('click', function() {
      let newMonth = parseInt(month) + 1;
      if (newMonth === 13) {
        newMonth = 1;
      }

      updateCalendar(listElement, inputElement, {
        'selectedMonth': newMonth,
      });

      updateDateSwitcher(newMonth);

      return false;
    });
  };

  /**
   * Delete Date
   * @param currentDate
   */
  window.deleteDate = function(currentDate) {
    const monthSwitcher = $('#month-switcher');
    const monthDays = $('.calendar-month-days');
    monthDays.find('.selected').removeClass('selected');

    const newMonth = currentDate.split('-');
    monthSwitcher.val(newMonth[1]);

    $(inputElement).val('');

    updateCalendar(listElement, inputElement, {
      'selectedMonth': newMonth[1], 'selectedDate': '',
    });
  };

  /**
   * Select Today
   * @param currentDate
   */
  window.selectCurrentDate = function(currentDate) {
    const monthSwitcher = $('#month-switcher');
    const monthDays = $('.calendar-month-days');
    monthDays.find('.selected').removeClass('selected');

    const newMonth = currentDate.split('-');
    monthSwitcher.val(newMonth[1]);

    $(inputElement).val(currentDate);

    updateCalendar(listElement, inputElement, {
      'selectedMonth': newMonth[1], 'selectedDate': currentDate,
    });
  };
};

window.initMultiCalendar = function(listElement, inputElement, params = {}) {
  var inputZeitspanenAuswahl = $('#input-zeitspanne-auswahl-gui');

  // Load Calendar
  $.ajax({
    url: BASE_PATH + 'ajax/helper/additional/ajax.getMultiCalendar?init=1', type: 'get', data: params, beforeSend: function() {
      insertAutoLoader($(listElement));
    }, success: function(html) {
      $(listElement).html(html);
      selectDay(inputElement);
    },
  });

  // Update Calendar
  window.updateCalendar = function(listElement, inputElement, params) {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/additional/ajax.getMultiCalendar', type: 'get', data: params, success: function(html) {
        $(listElement).html(html);
        selectDay(inputElement);
      },
    });
  };

  /**
   * Select Day
   * @param inputElement
   */
  window.selectDay = function(inputElement) {
    let currentInputElements = [];
    if ($(inputElement).val() !== '') {
      currentInputElements = $(inputElement).val().split(',');
    }
    // Selected
    $('.calendar-month-days .selectable').on('click', function() {
      if ($(this).hasClass('selected')) {
        if (inArray($(this).data('value'), currentInputElements)) {
          const currentValue = $(this).data('value');
          currentInputElements = $.grep(currentInputElements, function(value) {
            return value !== currentValue;
          });
        }

        $(this).removeClass('selected');
      } else {
        if (!inArray($(this).data('value'), currentInputElements)) {
          if ($(this).data('value') !== '') {
            currentInputElements.push($(this).data('value'));
          }
        }

        $(this).addClass('selected');
      }

      $(inputElement).val(currentInputElements.join(','));

      updateCalendar(listElement, inputElement, {
        'selectedDate': currentInputElements.join(','), 'minDate': (inputZeitspanenAuswahl.length > 0 ? inputZeitspanenAuswahl.attr('min') : ''),
      });
    });
  };

  /**
   * Update Month
   * @param element
   */
  window.updateMonthSelect = function(element) {
    updateCalendar(listElement, inputElement, {
      'selectedMonth': $(element).val(), 'minDate': (inputZeitspanenAuswahl.length > 0 ? inputZeitspanenAuswahl.attr('min') : ''),
    });
  };

  /**
   * updateDateSwitcher
   * @param month
   */
  window.updateDateSwitcher = function(month) {
    const monthSwitcher = $('#month-switcher');
    const prevSwitcher = $('#prev-switcher');
    const nextSwitcher = $('#next-switcher');

    monthSwitcher.val(month);

    if (parseInt(month) === 12) {
      nextSwitcher.attr('disabled', 'disabled');
    } else {
      nextSwitcher.removeAttr('disabled');
    }

    if (parseInt(month) === 1) {
      prevSwitcher.attr('disabled', 'disabled');
    } else {
      prevSwitcher.removeAttr('disabled');
    }

    prevSwitcher.unbind('click');
    prevSwitcher.on('click', function() {
      let newMonth = parseInt(month) - 1;
      if (newMonth === 0) {
        newMonth = 12;
      }

      updateCalendar(listElement, inputElement, {
        'selectedMonth': newMonth, 'minDate': (inputZeitspanenAuswahl.length > 0 ? inputZeitspanenAuswahl.attr('min') : ''),
      });

      updateDateSwitcher(newMonth);

      return false;
    });

    nextSwitcher.unbind('click');
    nextSwitcher.on('click', function() {
      let newMonth = parseInt(month) + 1;
      if (newMonth === 13) {
        newMonth = 1;
      }

      updateCalendar(listElement, inputElement, {
        'selectedMonth': newMonth, 'minDate': (inputZeitspanenAuswahl.length > 0 ? inputZeitspanenAuswahl.attr('min') : ''),
      });

      updateDateSwitcher(newMonth);

      return false;
    });
  };

  /**
   * Delete Date
   * @param currentDate
   */
  window.deleteDate = function(currentDate) {
    const monthSwitcher = $('#month-switcher');
    const monthDays = $('.calendar-month-days');
    monthDays.find('.selected').removeClass('selected');

    const newMonth = currentDate.split('-');
    monthSwitcher.val(newMonth[1]);

    $(inputElement).val('');

    updateCalendar(listElement, inputElement, {
      'selectedMonth': newMonth[1], 'selectedDate': '', 'minDate': (inputZeitspanenAuswahl.length > 0 ? inputZeitspanenAuswahl.attr('min') : ''),
    });
  };
};

/**
 * Rand
 * @param min
 * @param max
 * @returns {number}
 */
window.rand = function(min, max) {
  const argc = arguments.length;
  if (argc === 0) {
    min = 0;
    max = 2147483647;
  } else if (argc === 1) {
    throw new Error('Warning: rand() expects exactly 2 parameters, 1 given');
  }
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * inArray
 * @param needle
 * @param haystack
 * @param argStrict
 * @returns {boolean}
 */
window.inArray = function(needle, haystack, argStrict) {
  let key = '', strict = !!argStrict;

  //we prevent the double check (strict && arr[key] === ndl) || (!strict && arr[key] == ndl)
  //in just one for, in order to improve the performance
  //deciding wich type of comparation will do before walk array
  if (strict) {
    for (key in haystack) {
      if (haystack[key] === needle) {
        return true;
      }
    }
  } else {
    for (key in haystack) {
      if (haystack[key] === needle) {
        return true;
      }
    }
  }

  return false;
};

/**
 * inputNumberMinMax Fix
 */
window.inputNumberMinMax = function() {
  $('input[type="number"][min]').on('change', function() {
    const minValue = Number($(this).attr('min'));
    if (Number($(this).val()) < minValue) {
      $(this).val(minValue).trigger('input change');
    }
  });

  // Input type number max fix
  $('input[type="number"][max]').on('change', function() {
    const maxValue = Number($(this).attr('max'));
    if (Number($(this).val()) > maxValue) {
      $(this).val(maxValue).trigger('input change');
    }
  });
};

/**
 * parseDate
 * @param input
 * @returns {Date}
 */
window.parseDate = function(input) {
  const parts = input.match(/(\d+)/g);

  // bei Monat muss man 1 abziehen, da Monate als 0-11 und nicht 1-12 angegeben werden
  return new Date(parts[2], parts[1] - 1, parts[0]);
};

/**
 * formatDate
 * @param date
 * @param locale
 * @returns {string}
 */
window.formatDate = function(date, locale = 'de-DE') {
  return date.toLocaleDateString(locale, {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });
};

/**
 * Berechne Tage zwischen Start und Enddatum
 * @param d0
 * @param d1
 * @returns {number}
 */
window.countDays = function(d0, d1) {
  // To calculate the no. of days between two dates
  return (d1.getTime() - d0.getTime()) / (1000 * 3600 * 24);
};

/**
 * checkIconAfterLength
 * @param preLength
 */
window.checkIconAfterLength = function(preLength = 20) {
  const iconAfterLength = $('.checkIconAfterLength');
  if (iconAfterLength.length > 0) {
    iconAfterLength.each(function() {
      $(this).css('padding-right', ($(this).closest('label').find('.icon-after').width() + preLength) + 'px');
    });
  }
};

/**
 * findGetParameter
 * @param parameterName
 * @returns {null}
 */
window.findGetParameter = function(parameterName) {
  let result = null;
  let tmp = [];
  const items = location.search.substring(1).split('&');
  for (let index = 0; index < items.length; index++) {
    tmp = items[index].split('=');
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
};

/**
 * Search-Field with icon
 */
window.initSearchField = function() {
  const searchField = $('.search-field');
  if (searchField.length > 0) {
    searchField.before('<i class="material-icons search-icon">close</i>');
  }
  $('.search-icon').on('click', function() {
    const nextInput = $(this).next();
    nextInput.val('');
    nextInput.trigger('input');
  });
};

/**
 *
 * @param simulateID
 */
window.changeSimulateUser = function(simulateID) {
  window.location = '?simulateID=' + simulateID;
};